<nav class="navbar site-main-nav">
    <ul class="navbar-nav mr-auto">
      <li class="nav-item toggle-menu-container">
        <div class="nav-link-container">
          <div class="icon-nav-link">
            <span class="menu-icon" *ngIf="logo != ''">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="32"
                viewBox="0 0 32 32"
              >
                <g
                  id="Group_5283"
                  data-name="Group 5283"
                  transform="translate(-31 -189)"
                >
                  <circle
                    id="Ellipse_138"
                    data-name="Ellipse 138"
                    cx="16"
                    cy="16"
                    r="16"
                    transform="translate(31 189)"
                    fill="#e8e8e8"
                  />
                  <text
                    id="IS"
                    transform="translate(47 210)"
                    fill="#383838"
                    font-size="16"
                    font-family="ProximaNova-Bold, Proxima Nova"
                    font-weight="700"
                    text-anchor="middle"
                    dy="0.35em"
                  >
                    <tspan x="0" y="0" dx="-1" dy="-0.5">{{ logo }}</tspan>
                  </text>
                </g>
              </svg>
            </span>
            <a href="javascript:void(0)" class="nav-link">
              <strong>{{ accountName }}</strong>
            </a>
          </div>
          <span class="toggle-icon" (click)="toggleMenu()">
            <img
              src="/assets/images/icons/menu-close.svg"
              alt="toggle menu"
            />
          </span>
        </div>
      </li>
      <li class="nav-item account-info">
        <p>{{ customerName }}</p>
        <p>Account {{ displayCustomerNumber }}</p>
        <p>{{ accountAddress }}</p>
        <!-- <button
          *ngIf="logo != ''"
          class="change-account-btn"
          (click)="navigateToUserSearch()"
        >
          Exit <span class="mohawak-icon angle-right-icon"></span>
        </button> -->
      </li>
      <li
        class="nav-item level1-li"
        [ngClass]="'nav-item-index-' + i1"
        *ngFor="let level1 of menuConfig; let i1 = index"
        clickOutside
        (onClickOutside)="onClickedOutsideOfMenu('nav-item-index-', i1)"
      >
        <ng-container>
          <div class="nav-link-container">
            <div class="icon-nav-link">
              <span
                (mouseenter)="showTooltip = true"
                (mouseleave)="showTooltip = false"
                placement="right"
                containerClass="tooltip-primary"
                class="mohawak-icon menu-icon"
                (click)="onShowMenu($event, level1.name)"
                [ngClass]="level1.iconClass"
              ><img src="/assets/images/icons/{{level1.iconClass}}.svg" /></span>
              <span class="tooltiptext" [hidden]="!showTooltip">{{
                level1.name
              }}</span>
              <a
                href="javascript:void(0)"
                (click)="
                  level1.path
                    ? navigateToRoute(level1.path, $event, level1.isExternal)
                    : showSubMenu('level1-collapse-' + i1);
                  handleCollapse('level1', i1)
                "
                class="nav-link"
                >{{ level1.name }}</a
              >
            </div>
            <span
              *ngIf="level1.subNav"
              class="mohawak-icon bi bi-chevron-right"
              [id]="'level1-btn-' + i1"
              (click)=" level1.path
              ? navigateToRoute(level1.path, $event, level1.isExternal)
              : showSubMenu('level1-collapse-' + i1);handleCollapse('level1', i1)"
            ></span>
          </div>
        </ng-container>
        <div
          class="sub-menu mx-ngx-sub-menu"
          [id]="'level1-collapse-' + i1"
          style="display:none"
        >
          <div class="hover-header">
            <a
              href="javascript:void(0)"
              (click)="
                level1.path
                  ? navigateToRoute(level1.path, $event, level1.isExternal)
                  : ''
              "
              class="nav-link"
              >{{ level1.name }}</a
            >
          </div>
          <ng-container *ngIf="level1.subNav">
            <ul class="level2-nav">
              <li
                class="nav-item"
                *ngFor="let level2 of level1.subNav; let i2 = index"
              >
                <div class="nav-link-container">
                  <div class="icon-nav-link">
                    <a
                      href="javascript:void(0)"
                      (click)="
                        level2.path
                          ? navigateToRoute(
                              level2.path,
                              $event,
                              level2.isExternal,
                              level1
                            )
                          : '';
                        handleCollapse('level2', i2)
                      "
                      class="nav-link"
                      >{{ level2.name }}</a
                    >
                  </div>
                  <span
                    *ngIf="level2.subNav"
                    [id]="'level2-btn-' + i2"
                    class="mohawak-icon bi bi-chevron-right"
                    (click)="handleCollapse('level2', i2)"
                  ></span>
                </div>
                <div
                  id="main-nav"
                  [id]="'level2-collapse-' + i2"
                >
                  <ul class="level3-nav" *ngIf="level2.subNav">
                    <li class="nav-item" *ngFor="let level3 of level2.subNav">
                      <a
                        class="nav-link"
                        (click)="
                          navigateToRoute(
                            level3.path,
                            $event,
                            level2.isExternal,
                            level1
                          )
                        "
                        >{{ level3.name }}</a
                      >
                    </li>
                  </ul>
                </div>
              </li>
            </ul>
          </ng-container>
        </div>
      </li>
    </ul>
  </nav>
  